class Client {
    id = null;
    name = '';
    oib = '';
    iban = '';
    swift = '';
    address = '';
    city = '';
    postal_code = '';
    country = '';
    invoice_place_of_issue = '';
    invoice_footer_template_hr = '';
    invoice_footer_template_en = '';
    invoice_due_days_person = 0;
    invoice_due_days_company = 0;
    offer_footer_template_hr = '';
    offer_footer_template_en = '';
    offer_valid_days = 0;
    tax_system = false;
    logo = {};
    email_copy = '';
    fiskal = false;
    fiskal_certificate = {};
    fiskal_password = '';
    default_measurement_unit_id = 0;
    invoice_default_customer_id = 0;
    default_payment_method_id = 0;
    default_kpd_code = '';
    pdf_orientation = 'L';
    pdf_customer_offset_x = 0;
    pdf_customer_offset_y = 0;
    work_order_footer_template_hr = '';
    work_order_footer_template_en = '';
    ppo_template_hr = '';
    ppo_template_en = '';
    e_invoices_token = '';
    e_invoices_middleman = '';
    valid_until_display = '';
    invoice_document_format_id_1 = 1;
    invoice_document_format_id_2 = 1;
    invoice_document_format_id_3 = 1;
    invoice_document_format_id_4 = 1;
    dispatch_note_place_of_issue = '';
    dispatch_note_footer_template_hr = ';'
    dispatch_note_footer_template_en = ';'
    order_note_place_of_issue = '';
    order_note_footer_template_hr = '';
    order_note_footer_template_en = '';
    ignore_b2b_f1 = false;
    send_membership_reminder = false;
    membership_reminder_days = 7;
    membership_expiry_email_subject = '';
    membership_expiry_email_body = '';
    invoice_email_subject = '';
    invoice_email_body = '';
    offer_email_subject = '';
    offer_email_body = '';
    dispatch_note_email_subject = '';
    dispatch_note_email_body = '';
    order_note_email_subject = '';
    order_note_email_body = '';
    work_order_email_subject = '';
    work_order_email_body = '';
    use_smtp = false;
    smtp_host = '';
    smtp_port = 587;
    smtp_username = '';
    smtp_password = '';
    smtp_from_address = '';
    smtp_encryption = 'tls';
    fiskal_password_set = false;
    smtp_password_set = false;



    constructor(data = {}, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Client;
